import React from 'react';
import Joi from 'joi';
import PropTypes from 'prop-types';

import AutTable from '../../blocks/aut-grid-table/index';
import Conditional from '../../common/conditional';
import Form from '../../common/form';
import HelideckTieTestItem from './helideckTieTestItem';

import * as data from '../../../utils/data';
import * as models from '../../../utils/models';

class HelideckTieTestItemsForm extends Form {
	state = {
		data: { items: [] },
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		items: Joi.array()
			.min(1)
			.items(
				Joi.object({
					id: Joi.number().positive().required().label('ID'),
					netNumber: Joi.string().allow('').required().label('Net Number'),
					testPressure: Joi.number().min(0).required().label('Test Pressure'),
					result: Joi.string().required().label('Result'),
				})
			)
			.required()
			.label('Inspection Items'),
	};

	static propTypes = {
		onProceed: PropTypes.func,
	};

	onAddItem = (item: models.HelideckTieTestItem) => {
		const data: any = { ...this.state.data };
		data.items = [...data.items];
		data.items.push({ ...item, id: data.items.length + 1 });

		this.setState({ data });
	};

	onDeleteItem = (item: models.HelideckTieTestItem): void => {
		const data = { ...this.state.data };
		data.items = data.items.filter(
			(i: models.HelideckTieTestItem) => i.id !== item.id
		);

		this.setState({ data });
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onProceed(this.state.data.items);

		this.setState({ data: { items: [] } });
	};

	render() {
		return (
			<React.Fragment>
				<HelideckTieTestItem onAdd={this.onAddItem} />

				<AutTable
					tableColumns={data.getHelideckTDColumns()}
					data={this.state.data.items}
					onDeleteItem={this.onDeleteItem}
				/>

				<Conditional isVisible={this.state.data.items.length > 0}>
					<form autoComplete="off" onSubmit={this.handleSubmit}>
						{this.renderButton('Finish')}
					</form>
				</Conditional>
			</React.Fragment>
		);
	}
}

export default HelideckTieTestItemsForm;
